module.exports = __webpack_public_path__ + "images/jobs/cardCybersecurite.f1eb5bcd.svg";